import qs from "qs";
import axios from "axios";
import { energyApi } from "utilities/Axios";

export const authenticateUser = async (loginDetails: { email: string, password: string }) => {
  return energyApi.post("/api/Auth/login", loginDetails);
};

export const register = async (data: any) => {
  // return axios.post(`${baseUrl}/auth/register`, data);
};

export const forgetPassword = (data: any) => {
  //return axios.post(`${baseUrl}/auth/forgotpassword`, null, { params: data });
};

export const logout = () => {
  //return commonApi.get("/api/auth/sign-out");
};
